// Generated by CoffeeScript 1.12.2
(function () {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };

    hrtime = process.hrtime;

    getNanoSeconds = function () {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };

    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };

    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };

    loadTime = new Date().getTime();
  }
}).call(this);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wZXJmb3JtYW5jZS1ub3cuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxDQUFBLFlBQUE7QUFBQSxNQUFBLGNBQUEsRUFBQSxNQUFBLEVBQUEsUUFBQSxFQUFBLGNBQUEsRUFBQSxZQUFBLEVBQUEsTUFBQTs7QUFBQSxNQUFHLE9BQUEsV0FBQSxLQUFBLFdBQUEsSUFBQSxXQUFBLEtBQUEsSUFBQSxJQUFpQixXQUFXLENBQS9CLEdBQUEsRUFBQTtBQUNFLElBQUEsTUFBTSxDQUFOLE9BQUEsR0FBaUIsWUFBQTthQUFHLFdBQVcsQ0FBWCxHQUFBLEU7QUFEdEIsS0FDRTtBQURGLEdBQUEsTUFFSyxJQUFHLE9BQUEsT0FBQSxLQUFBLFdBQUEsSUFBQSxPQUFBLEtBQUEsSUFBQSxJQUFhLE9BQU8sQ0FBdkIsTUFBQSxFQUFBO0FBQ0gsSUFBQSxNQUFNLENBQU4sT0FBQSxHQUFpQixZQUFBO2FBQUcsQ0FBQyxjQUFBLEtBQUQsWUFBQSxJQUFvQyxHO0FBQXZDLEtBQWpCOztBQUNBLElBQUEsTUFBQSxHQUFTLE9BQU8sQ0FBQyxNQUFqQjs7QUFDQSxJQUFBLGNBQUEsR0FBaUIsWUFBQTtBQUNmLFVBQUEsRUFBQTtBQUFBLE1BQUEsRUFBQSxHQUFLLE1BQUEsRUFBTDthQUNBLEVBQUcsQ0FBSCxDQUFHLENBQUgsR0FBQSxHQUFBLEdBQWMsRUFBRyxDQUFBLENBQUEsQztBQUZGLEtBQWpCOztBQUdBLElBQUEsY0FBQSxHQUFpQixjQUFBLEVBQWpCO0FBQ0EsSUFBQSxNQUFBLEdBQVMsT0FBTyxDQUFQLE1BQUEsS0FBbUIsR0FBNUI7QUFDQSxJQUFBLFlBQUEsR0FBZSxjQUFBLEdBUlosTUFRSDtBQVJHLEdBQUEsTUFTQSxJQUFHLElBQUksQ0FBUCxHQUFBLEVBQUE7QUFDSCxJQUFBLE1BQU0sQ0FBTixPQUFBLEdBQWlCLFlBQUE7YUFBRyxJQUFJLENBQUosR0FBQSxLQUFhLFE7QUFBaEIsS0FBakI7O0FBQ0EsSUFBQSxRQUFBLEdBQVcsSUFBSSxDQUZaLEdBRVEsRUFBWDtBQUZHLEdBQUEsTUFBQTtBQUlILElBQUEsTUFBTSxDQUFOLE9BQUEsR0FBaUIsWUFBQTthQUFPLElBQUEsSUFBQSxHQUFKLE9BQUksS0FBbUIsUTtBQUExQixLQUFqQjs7QUFDQSxJQUFBLFFBQUEsR0FBZSxJQUFBLElBQUEsR0FMWixPQUtZLEVBQWY7O0NBaEJGLEUsSUFBQSxDLElBQUEiLCJzb3VyY2VSb290IjoiLi4ifQ==